import Card from '@/components/atoms/Card';
import { cn } from '@/lib/utils';

import ProductCardButton from './ProductCardButton';
import ProductCardDescription from './ProductCardDescription';
import ProductCardFeatures from './ProductCardFeatures';
import ProductCardTitle from './ProductCardTitle';
import ProductCardUseCases from './ProductCardUseCases';
import { ProductCardProps } from './types';

type Props = ProductCardProps & { className?: string };

export default function ProductCardWithUseCases({
  icon,
  title,
  subtitle,
  description,
  button,
  features,
  useCases,
  className,
}: Props) {
  return (
    <Card
      classNames={{
        root: cn(
          'h-full rounded-md flex flex-col md:flex-row justify-between gap-8 text-left border-brand-300 dark:border-brand-700 shadow-sm dark:shadow-none bg-base-white',
          className
        ),
      }}
    >
      <div className='flex-1'>
        <ProductCardTitle
          icon={icon}
          title={title}
          subtitle={subtitle}
          isCardFullWidth
        />
        <ProductCardDescription description={description} isCardFullWidth />
        {!!features?.length && <ProductCardFeatures features={features} />}
        {button && <ProductCardButton button={button} isCardFullWidth />}
      </div>
      <div className='flex-1'>
        {!!useCases?.length && <ProductCardUseCases useCases={useCases} />}
      </div>
    </Card>
  );
}
